import { Route, Routes } from 'react-router-dom';

import QsightNavbar from './components/QsightNavbar';
import { Outlet } from 'react-router-dom';

import { ReportProvider } from './components/shared/context/ReportProvider';
import AutoParPage from './modules/autopar/pages/AutoParPage';


const ReportRoutes = [
  <Route key={1} path='/' element={<AutoParPage />} />,
];

const ReportRoutesWithoutHeader = () => {
  return <ReportProvider><Routes>{ReportRoutes.map(reportRoute => reportRoute)}</Routes></ReportProvider>;
};

const ReportRoutesWithHeader = () => {
  return (
    <ReportProvider>
      <Routes>
        <Route path='/' element={<QsightNavbar />}>
          {ReportRoutes.map(reportRoute => reportRoute)}
        </Route>
      </Routes>
    </ReportProvider>
  );
};

export { ReportRoutesWithHeader, ReportRoutesWithoutHeader };
